export const PAGE_BG = '#f7f7f7'
export const SURFACE = '#ffffff'
export const BORDER = '#e6e6e6'
export const DIVIDER = '#f0f0f0'
export const TEXT = '#111111'
export const MUTED_TEXT = '#6b6b6b'
export const VALUE_TEXT = '#555555'
export const BUTTON_BG = '#f1f1f1'
export const BUTTON_HOVER_BG = '#e6e6e6'
export const NAV_SELECTED_BG = '#e9e9e9'
export const NAV_HOVER_BG = '#efefef'
export const TRACK_BG = '#ededed'

export type Tone = 'success' | 'warning' | 'error' | 'neutral'

export const TONES: Record<Tone, { fg: string; bg: string; dot: string }> = {
  success: { fg: '#1f6b37', bg: '#e8f5ec', dot: '#1f8a45' },
  warning: { fg: '#6b4600', bg: '#fff1d6', dot: '#c98a00' },
  error: { fg: '#b42318', bg: '#fdecea', dot: '#b42318' },
  neutral: { fg: '#444444', bg: '#ededed', dot: '#8c8c8c' },
}

export const ATTENTION = {
  border: '#f1d19a',
  headerBg: '#fff8eb',
  headerBorder: '#f6e3c0',
  icon: '#8a5a00',
}
